import React from 'react';
import classNames from 'classnames';
import NewsFeatures from '../news-features';
const News = ({ className }) => {
    return (<div className={classNames('News', className)}>
            <NewsFeatures />
        </div>);
};
export default News;
